export const subUrl = "";
const loginPageBase = (
    process.env.REACT_APP_FRONTEND_URL_LOGIN_PAGE || ""
  ).replace(/\/$/, "");
  
  export const toLoginPageUrl = (path = "") => {
    if (!path) return loginPageBase;
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${loginPageBase}${normalizedPath}`;
  };
export const login = subUrl + "/login";
export const signup = subUrl + "/signup";
export const manualdownload = subUrl + "/download";
// client
export const clientHome = subUrl + "/home";
export const clientNewsDetail = subUrl + "/news/:id";
export const clientNewsDocument = subUrl + "/docs/:id";
